import React, { useState } from "react";
import { useLanguage } from "./LanguageContext"; // Adjust the import path
import Icon from "components/AppIcon";
const LanguageSwitcher = () => {
  const { changeLanguage } = useLanguage();

  const [language, setLanguage] = useState("en");

    const [isScrolled, setIsScrolled] = useState(false);

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "en" ? "ar" : "en"));
    changeLanguage(language == "en" ? "ar" : "en");
  };

  return (
    <div>
      <button
        onClick={toggleLanguage}
        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
      >
        <Icon name="Globe" size={20} color="green"  />
      </button>
    </div>
  );
};

export default LanguageSwitcher;
